import type { I18n } from '@lingui/core'

import {
  LANGUAGE_DE,
  LANGUAGE_FR,
  LANGUAGE_IT,
  LANGUAGE_NL,
} from 'shared/consts/languages'
import logger from 'shared/services/logger'
import { type AlternativeUrls } from 'types/shopConfig'

export const getTitle = (language: string, i18n: I18n) => {
  switch (language) {
    case LANGUAGE_DE:
      return i18n._('general.label.german')
    case LANGUAGE_FR:
      return i18n._('general.label.french')
    case LANGUAGE_IT:
      return i18n._('general.label.italian')
    case LANGUAGE_NL:
      return i18n._('general.label.dutch')
    default:
      logger.warn(`Invalid language was passed: ${language}`)

      return language
  }
}

export const getLanguagesOptions = (
  activeLanguage: string,
  alternativeUrls: AlternativeUrls,
  i18n: I18n
) =>
  Object.entries(alternativeUrls).map(([language, { path, fallback }]) => ({
    text: getTitle(language, i18n),
    href: path || fallback,
    code: language,
    selected: activeLanguage === language,
  }))
